import { useState } from "react";
import type { Ritual } from "@akhshy/types";
import { renderMarkdown } from "../../lib/markdown.tsx";

export function RitualEntry({ ritual }: { ritual: Ritual }) {
  const [open, setOpen] = useState(false);

  return (
    <article className="ritual-entry" data-open={open}>
      <button
        type="button"
        className="ritual-toggle"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="r-title">{ritual.title}</span>
        <span className="r-date">
          {ritual.displayDate} <span className="r-hint">· {open ? "fold" : "unfold"}</span>
        </span>
      </button>
      <div className="ritual-body">{renderMarkdown(ritual.content)}</div>
    </article>
  );
}
